<mat-card appearance="outlined">
    <form class="fix-editor">
        <mat-form-field class="ag-row fix-mat-form">
            <input
                matInput
                [type]="inputType()"
                [formControl]="maskedDateFormControl()"
                dateMask
                [maskOptions]="maskConfigOptions"
                [ready]="cellReady()"
                [focusSelectOn]="cellReady()"
            />
            @if (maskedDateFormControl()?.hasError("required")) {
                <mat-error>
                    {{ "se-ui-datagrid_required_value_constraint" | translate }}
                </mat-error>
            }
        </mat-form-field>
    </form>
</mat-card>
